<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8 md6 lg5 xl4>
      <v-card>
        <v-toolbar dark color="#000000" align="center" justify="center">
          <v-toolbar-title>ADMIN GAS</v-toolbar-title>
        </v-toolbar>
        <v-card-actions class="px-3 pb-3" align="center" justify="center">
          <v-flex text-xs-center>
            <v-img :src="require('../assets/logo.png')" height="200" width="300"></v-img>
            
          </v-flex>
        </v-card-actions>
        <v-card-text>
          <v-text-field v-model="email" autofocus color="accent" label="Usuario" required></v-text-field>
          <v-text-field v-model="password" type="password" color="accent" label="Password" required></v-text-field>
          <v-flex class="red--text" v-if="error">{{error}}</v-flex>
        </v-card-text>
        <v-card-actions class="px-3 pb-3" align="center" justify="center">
          <v-flex text-xs-center>
            <v-btn @click="ingresar" color="primary">Ingresar</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      email: "",
      password: "",
      error: null,
    };
  },
  methods: {
    ingresar() {
      this.error = null;
      // Mandamos el email y password para verificar que si existan
      var qs = require('qs');
      var data = qs.stringify({
        'json': '{"usuariomail":"'+this.email+'","usuariopassword":"'+this.password+'"}' 
      });
      axios
        .post("api/usuarios/login", {
          usuariomail:this.email,
          usuariopassword:this.password
        })
        .then(respuesta => {
          // en la variable respuesta mandamos todos los datos recibidos
          //console.log(respuesta.data);
          //console.log(JSON.stringify(respuesta.data));
          return respuesta.data;
        })
        .then(data => {
          // Guarda el token en la ruta store
          this.$store.dispatch("guardarToken", data.token);
          // Manda a la ruta  router de home
          this.$router.push({ name: "home" });
        })
        .catch(err => {
          // Valida si no existe ek mail
          if (err.message == "Invalid token specified") {
            this.error = "Usuario o email no son válidos";
          } 
          //console.log(err)
        });
    }
  }
};
</script>

